import angular from 'angular';

const exhibitorsServices = angular.module('applicationModule.exhibitorsServices', []);

exhibitorsServices.factory('Exhibitor', ['ExhibitorsAPI', 'Upload', 'AppsoupAPI', function (ExhibitorsAPI, Upload, AppsoupAPI) {
    'use strict';

    const checkFiles = function (file, file_mini) {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }
        if (angular.isDefined(file_mini)) {
            files.push(file_mini);
            names.push('file_mini');
        }

        return {files: files, names: names};
    };

    return {
        getList: function (appId, params) {
            return ExhibitorsAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (exhibitorId, appId) {
            return ExhibitorsAPI.getExhibitor(exhibitorId, appId);
        },
        save: function (exhibitor, file, file_mini, editMode) {
            angular.forEach(exhibitor, function (val, key) {
                if (angular.isNullOrUndefined(val)) {
                    delete exhibitor[key];
                }
            });
            const API_URL = AppsoupAPI.API_URL + '/app/exhibitor/';
            const files = checkFiles(file, file_mini);
            if (editMode) {
                if (angular.isDefined(file) || angular.isDefined(file_mini)) {
                    const newfields = angular.extend(exhibitor, {_method: 'PUT'});

                    return Upload.upload({
                        url: API_URL + 'update/' + exhibitor.id,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newfields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return ExhibitorsAPI.editExhibitor(exhibitor);
                }
            } else {
                if (angular.isDefined(file) || angular.isDefined(file_mini)) {
                    return Upload.upload({
                        url: API_URL + 'create',
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: exhibitor,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return ExhibitorsAPI.createExhibitor(exhibitor);
                }
            }
        },
        remove: function (productId, appId) {
            return ExhibitorsAPI.removeExhibitor(productId, appId);
        }
    };
}]);

exhibitorsServices.service('ExhibitorsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/exhibitor/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.createExhibitor = function (exhibitor) {
        return $http.post(API_URL + 'create', exhibitor);
    };
    this.getExhibitor = function (exhibitorId, appId) {
        return $http.get(API_URL + exhibitorId + '/' + appId);
    };

    this.editExhibitor = function (exhibitor) {
        return $http.put(API_URL + 'update/' + exhibitor.id, exhibitor);
    };

    this.removeExhibitor = function (exhibitorId, appId) {
        return $http.delete(API_URL + 'delete/' + exhibitorId + '/' + appId);
    };

}]);

export default exhibitorsServices;
